/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { subscriptionFormPostRequestSchema } from './subscriptionFormPostRequestSchema.ts';
import { subscriptionFormPostResponseSchema } from './subscriptionFormPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postSubscriptionForm200Schema = z.lazy(() => subscriptionFormPostResponseSchema);

/**
 * @description 505 response
 */
export const postSubscriptionForm505Schema = z.any();

export const postSubscriptionFormMutationRequestSchema = z.lazy(() => subscriptionFormPostRequestSchema);

export const postSubscriptionFormMutationResponseSchema = z.lazy(() => postSubscriptionForm200Schema);
